/**
 * @format
 */
import angular from 'angular';
import { ModalService } from 'sis-common';
import { EnrolmentQuestionnaireModalComponent } from 'sis-components/enrolmentQuestionnaire/enrolmentQuestionnaireModal-ng.component.ts';
import { enrolmentQuestionnaireModalModule } from 'sis-components/enrolmentQuestionnaire/enrolmentQuestionnaireModal.component';
import { enrolmentCalculationModule } from 'sis-components/service/enrolmentCalculation.service';
import { planServiceModule } from '../../../service/planService';
export const enrolmentModalServiceModule = 'student.common.components.course-unit-realisation.enrolmentModalService';
(function () {
  enrolmentModalService.$inject = ["modalService"];
  angular.module(enrolmentModalServiceModule, [planServiceModule, enrolmentQuestionnaireModalModule, ModalService.downgrade.moduleName, enrolmentCalculationModule]).service('enrolmentModalService', enrolmentModalService);
  function enrolmentModalService(modalService) {
    return {
      openEnrolmentQuestionnaireModal(enrolmentQuestionnaire, enrolmentQuestionnaireAnswers, courseUnitRealisation) {
        return modalService.open(EnrolmentQuestionnaireModalComponent, {
          enrolmentQuestionnaire,
          enrolmentQuestionnaireAnswers,
          courseUnitRealisation
        }, {
          size: 'sm',
          closeWithOutsideClick: true
        }).result;
      }
    };
  }
})();